export default __webpack_public_path__ + "static/media/logo.f2d58ec5.svg";